<template>
  <v-container>
    <v-card class="mb-3">
      <v-card-title><h1>Bonjour {{user.prenom}}</h1></v-card-title>
      <v-card-text>
        <h3>Vos prochains horaires:</h3>
        <v-sheet
      tile
      height="54"
      class="d-flex"
    >
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.prev()"
      >
        <v-icon>mdi-chevron-left</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <h2>{{moment(value).format("MMMM yyyy")}}</h2>
      <v-spacer></v-spacer>
      <v-btn
        icon
        class="ma-2"
        @click="$refs.calendar.next()"
      >
        <v-icon>mdi-chevron-right</v-icon>
      </v-btn>
    </v-sheet>
        <v-calendar
        :type="type"
        locale="fr-FR"
        ref="calendar"
        v-model="value"
        :events="events"
        :weekdays="[1, 2, 3, 4, 5, 6, 0]"
        :event-overlap-threshold="30"
        :event-overlap-mode="'column'"
        :event-color="getEventColor"
        @click:event="showEvent"
      ></v-calendar>
      </v-card-text>
       <v-menu
          v-model="selectedOpen"
          :close-on-content-click="false"
          :activator="selectedElement"
          offset-x
        >
          <v-card
            color="grey lighten-4"
            min-width="350px"
            flat
          >
            <v-toolbar
              :color="selectedEvent.color"
              dark
            >
              <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
            </v-toolbar>
          </v-card>
        </v-menu>
    </v-card>
    <v-row>
      <v-col md=6 xs=12 sm=12>
        <v-card>
          <v-card-title>
            <h2>Ce mois-ci, vous avez travaillé</h2>
          </v-card-title>
          <v-card-text>
            <h2 v-if="total">{{total.split(':')[0]}} heure(s) et {{total.split(':')[1]}} minute(s)</h2>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import store from "@/store/index.js";
  import api from "@/api";
  import moment from "moment";
  export default {
    data() {
      return {
        value:moment().format("YYYY-MM-DD"),
        news: {},
        fields: [
          {value:"from", text:"De"},
          {value:"to",text:"A"}
        ],
        type:'month',
        selectedEvent: {},
        selectedElement: null,
        selectedOpen: false,
        sites: [],
        sitesById: [],
        fonctions: [],
        fonctionsById: [],
        horaires: [],
        vacances: [],
        events: [],
        periodes: [],
        date: moment(),
        moment:moment,
        total: 0
      }
    },
    created(){
      this.loadData();
    },
     methods: {
       async loadData(){
      // this.news = (await api.getNews()).data;
      this.fonctions = (await api.getFonctions()).data.fonctions;
      for (let fonction of this.fonctions) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.sites = (await api.getSites()).data.sites;
      for (let site of this.sites) {
        this.sitesById[site.id] = site;
      }
      this.horaires = (await api.getHorairesPerso()).data.horaires;
      this.vacances = (await api.getVacances(2021)).data.vacances;
      for (let vacance of this.vacances){
            this.events.push({
              name: "Vacances",
              start: moment(vacance.debut).toDate(),
              end: moment(vacance.fin).toDate(),
              color: '#000000',
              timed: false
            });
      }
      for (let horaire of this.horaires){
            let n = ""
            if (horaire.h10) n+= "10h ";
            if (horaire.h14) n+= "14h ";
            if (horaire.h16) n+= "16h ";
            if (horaire.h18) n+= "18h ";
            if (horaire.h20) n+= "20h ";
            if (horaire.matin) n+= "Matin ";
            if (horaire.apresmidi) n+= "Après-midi ";
            if (horaire.bureau) n+= "Bureau ";
            n+= " ["+this.fonctionsById[horaire.id_fonction].nom + ", " + this.sitesById[horaire.id_site].nom + "]";
            this.events.push({
              name: n,
              start: moment(horaire.date).toDate(),
              end: moment(horaire.date).toDate(),
              color: horaire.id_fonction === 0 ? '#2a3ef5' : (horaire.id_fonction === 1) ? '#c7165d' : (horaire.id_fonction === 2) ? '#1e9c6f' : (horaire.id_fonction === 3) ? '#1e9c6f' : (horaire.id_fonction === 4) ? '#c78748' : '#4d9edb',
              timed: false
            });
        }


        this.periodes = (await api.getPeriodes()).data.periodes;
        let today = moment();
        let ok = false;
        for (let i = 0; i < this.periodes.length; i++) {
          let diff =
            moment(this.periodes[i][1]).year() - moment(this.periodes[i][0]).year();
          let a = moment(this.periodes[i][0]).set("year", today.year() - diff);
          let b = moment(this.periodes[i][1]).set("year", today.year());
          if (today.isBetween(a, b, undefined, "[]")) {
            today.set("month", i);
            ok = true;
            break;
          }
        }
        if (!ok) {
          today.add(1, "month");
        }
        this.date = today.format("yyyy-MM");
        let month = moment(this.date).month();
        let year = moment(this.date).year();
        let diff =
          moment(this.periodes[month][1]).year() -
          moment(this.periodes[month][0]).year(); //On recale l'année des périodes sur l'année en cours
        this.begin = moment(this.periodes[month][0]).set("year", year - diff);
        this.end = moment(this.periodes[month][1]).set("year", year);
        let response = (
          await api.getHeures(this.begin.format("YYYY-MM-DD"), this.end.format("YYYY-MM-DD"))
        ).data;
        this.total = response.total;
       },
      getEventColor (event) {
        return event.color
      },showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          requestAnimationFrame(() => requestAnimationFrame(() => this.selectedOpen = true))
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          requestAnimationFrame(() => requestAnimationFrame(() => open()))
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
     },
     
    computed: {
      user() {
        return store.state.user;
      },
    }
  }
</script>
